// extracted by mini-css-extract-plugin
export default {"msg-container":"ErrorMessage_msg-container__aJ-u+","msg-title":"ErrorMessage_msg-title__az3Yg"};